/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { use, useContext, useEffect, useRef, useState } from 'react';
import { Link,useNavigate } from 'react-router-dom'
import './header.css'
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { UserContext } from '../../store/contexts/UserContextProvider';
import ActionButton from '../../components/buttons/actionbutton';
import { PopupCloseContext, UserInitalValue } from '../../store/contexts/popupclose-context'
import Popups from '../../components/popup/popupwithposition'
import Notifications from '../../components/notifications/notifications'
import { DeviceDetailsContext } from '../../store/contexts/UserDeviceContextProvider';
import { msalMobileLogout } from '../../shared/utils/mobileMSAL';
import { OTP_LOGIN, RHYBUS_ACCESS_TOKEN, RHYBUS_REFRESH_TOKEN } from '../../Configuration';
import Buttons from '../../components/buttons/buttons';
import { handleLogout } from '../../tokenUtils';
import { IDB_INQUIRY_LIST_STORE } from '../../shared/constants/globalConstants';
import AskAIButton from '../../components/chatbot/ask-ai-button';
import { deleteIDB } from '../../store/indexed-db/indexedDBHelper';
import GlobalSearchHeader from '../../modules/TRM/pages/global-search/global-search-header';

interface Props{
    toogleNotification: boolean,
    onLogout: () => void;
}
const Header = (props:Props) => {
      const navigate = useNavigate();
    const {isMobile,isWeb}=useContext(DeviceDetailsContext)
    const [intials, setIntials] = useState('')
    const { accounts, instance } = useMsal()
    const [fullName, setFullName] = useState<any>('')
    const [email, setEmail] = useState<any>('')
    const isAuthenticated = useIsAuthenticated()
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [userApplications, setuserApplications] = useState<any>([]);
    const [isMobileApp, setIsMobileApp] = useState(false);
    const [windowSize, setWindowSize] = useState(getWindowSize())
     const [completeName, setcompleteName] = useState<any>('')
    const { me } = useContext(UserContext)
    // UserContext's `me` is the same /me response, so derive the display values from it
    // instead of requesting /me again (previously once on mount and again when userId resolved).
    useEffect(() => {
        if (me?.userId) {
            getUserInfo();
        }
    }, [me])

    const getUserInfo = () => {
        const meValue = me
        let ufirstname: any = meValue?.firstName?.substring(0, 1);
        let ulastname: any = meValue?.lastName && meValue?.lastName !== null ?meValue.lastName.substring(0, 1):'';
        let completename: any = meValue?.profileName && meValue?.profileName !== null ?meValue.profileName :meValue.firstName + ' ' + meValue.lastName;
        setIntials(ufirstname + ulastname)
        setFullName(ufirstname + ulastname);
        setcompleteName(completename);
        setEmail(meValue?.email);
    }

    const togglePopup = () => {
        setPopupVisible(!isPopupVisible);
    };
    const isotpToken = localStorage.getItem(OTP_LOGIN);
    const handleSignOut = () => {
        void deleteIDB(IDB_INQUIRY_LIST_STORE);
        localStorage.clear();
        sessionStorage.clear();
        setIsLoggedIn(false);
        //Closing popup on logout
        setMultiplePopup(null);
        localStorage.setItem(RHYBUS_ACCESS_TOKEN,'');
        localStorage.setItem(RHYBUS_REFRESH_TOKEN,'');
        localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
        localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
        if(!isWeb && isMobile){
            msalMobileLogout()
        }else
        setIsLoggedIn(false);     
         if(isotpToken === 'true'){   
            props.onLogout(); // tell App to go back to login
         }
         else{
        ////--------------For MSAL logout---------------------
        navigate('/signout')
      
       ////------------------End-------------------------------------------
         }
    //  document.title = "Anew-Title and Registration Management";
     
        
    };
   

    const redirectUserApplication = (url: any) => {
        window.open(url, '_blank');
    };

    // Context for handling multiple popups
    const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)
    const profilePopup = useRef<HTMLButtonElement>(null)

    const PopupWindow = (ele: string) => {
        setMultiplePopup((prevPopup: string | null) => (prevPopup === ele ? null : ele))
    }

    function getWindowSize() {
        const { innerWidth, innerHeight } = window
        return { innerWidth, innerHeight }
    }
    useEffect(() => {
        if (windowSize.innerWidth < 1024) {
            setIsMobileApp(true)
        } else {
            setIsMobileApp(false)
        }
    }, [windowSize]);

    const topHeader = (
        <div className={`header d-flex w-100 ${multiplePopup === 'notification-popup' ? 'notify-popup':''}`}>
            <div className='container d-flex align-items-center'>               
                <div className='d-flex gap-2 p-lg-relative align-items-center flex-wrap w-100 h-100 justify-content-end px-lg-2'>
                    <div className='ps-4 col d-flex flex-column d-none-lg line-clamp-1'>
                        <h2 className='sora-bold font-16 text-color-34 line-clamp-1 text-capitalize' tabIndex={0} aria-label={me?.profileName ?? undefined}>                           
                            {me?.profileName}
                        </h2>
                        <p aria-label='Welcome to TRM' tabIndex={0} className='font-12 sora-regular text-color-73'>Welcome to TRM</p>
                    </div>
                     <span className='ms-auto'></span>
                     <div>
                        <GlobalSearchHeader/>
                     </div> 
                     <div className='divider vertical d-none d-block-md'></div>
                     <div>
                        <AskAIButton ismobile={isMobileApp} />
                     </div>                     
                     <Notifications toogleNotification={props?.toogleNotification}/>   
                     <div className='divider vertical d-none d-block-md'></div>                     
                    <div className='profilepic d-flex align-items-center'>
                        <ActionButton
                            id={intials}
                            label={intials}
                            name={intials}
                            className='btn-border-6 whitetext d-flex justify-content-center text-center userbutton'
                            type="button"                            
                            aria-expanded={multiplePopup === 'profile-popup' ? 'true' : 'false'}
                            ref={profilePopup}
                            onClick={() => PopupWindow('profile-popup')}
                        />
                        {multiplePopup === 'profile-popup' && (
                            <Popups
                                popuparrow={false}
                                buttonRef={profilePopup}
                                popupId='profile-popup'
                                className="dropdown-popup whitebg min-w-300 border-radius-2 profile-popup-md fade-in"
                                closebtnclass="icon-rb-close font-10 darktext"
                                popupclosebtnclassName="btn-sm profile-popup-close cursor btn-border-radius-3"
                                popupContent={
                                    <>
                                        <div className='d-flex align-items-center w-100 p-3'>
                                            <div tabIndex={0} aria-label='Anew Transport' className='sora-semibold font-14 text-color-84'>Anew Transport</div>
                                            <button onClick={()=>{PopupWindow('profile-popup');handleLogout();}} title='Sign Out' className='no-border btn-sm text-color-11 sora-semibold me-2 whitebg font-10 ms-auto cursor'>Sign out</button>
                                            <Buttons aria-label="Close Popup" className="btn-sm bgcolor-31 p-2" icon="icon-rb-close font-10 text-color-39" onClick={() => PopupWindow('profile-popup')}/>
                                        </div>
                                        <div className='d-flex align-items-center w-100 pb-3 px-3'>
                                            <div className='circleName border-2 me-3 line-clamp-1'>
                                                {fullName}
                                            </div>
                                            <div className='user_accountDetails '>
                                                <div className='sora-semibold font-14 text-break text-color-85 text-capitalize' tabIndex={0} aria-label={me?.profileName ?? undefined}>{me?.profileName}</div>
                                                <p className='py-1 line-clamp-1 text-color-27 font-10' tabIndex={0} aria-label={me?.email}>{me?.email}</p>
                                                {/* <Link to="/profile" className='links text-color-11 sora-semibold font-10' title='View Profile'>
                                                    View Profile
                                                </Link> */}
                                            </div>
                                        </div>                                        
                                    </>
                                }

                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <div className="page-container">            
            {topHeader}
            {isLoggedIn ? (
                ""
            ) : (
                <div className="welcome-message">
                    You are not logged in. Please login to continue.
                </div>
            )}
        </div>
    );
};
export default Header;
